import { ExperimentConfig } from "./types"

/**
 * Centralized configuration for all experiments
 *
 * Add new experiments here with their variants and filters.
 */
export const NEWSLETTERS_EXPERIMENT_ID = "01JFXQ8ZY6WNBVP2KR3MXHQ4JT"
export const NEWSLETTERS_EXPERIMENT_CONTROL_ID = "01JFXQ8ZY6B9C1D3E5F7G9H2JK"
export const NEWSLETTERS_EXPERIMENT_VARIANT_ID = "01JFXQ8ZY6A7N8P9Q2R5STUVWX"

export const EXPERIMENTS: Record<string, ExperimentConfig> = {
  [NEWSLETTERS_EXPERIMENT_ID]: {
    enabled: true,
    variants: [
      { id: NEWSLETTERS_EXPERIMENT_CONTROL_ID, weight: 0 },
      { id: NEWSLETTERS_EXPERIMENT_VARIANT_ID, weight: 100 },
    ],
    filters: {
      excludeLoggedInUsers: false,
    },
  },
}
